export const fr = {
  landingPageForCompanies: {
    book_a_demo: 'Réserver une démo',
    company_logos_desc: 'La confiance des équipes de',

    blogSection: {
      title: 'Notre blogue',
      subtext: 'Articles et témoignages sur le bénévolat d\'entreprise et l\'impact social',
      viewMore: 'Voir plus →',
    },

    hero: {
      headline_main: 'Le bénévolat d\'entreprise',
      headline_em: 'qui fonctionne vraiment',
      sub: "Purposely gère le jumelage avec les organismes, la logistique des événements et les rapports d'impact — pour que votre portée passe d'un bureau à des centaines",
      cta_primary: 'Voir en action →',
    },

    howItWorks: {
      eyebrow: 'Comment ça marche',
      heading_main: 'Les autres plateformes listent des événements',
      heading_em: 'La nôtre les gère',
      tagline: "Les outils traditionnels vous donnent un répertoire. L'IA de Purposely gère le jumelage, les opérations et l'impact de bout en bout.",
      step1: {
        title: "Informez Purposely",
        body: "Indiquez à Purposely la taille de votre groupe, votre emplacement et l'impact qui vous tient à cœur. Une minute et c'est parti.",
      },
      step2: {
        title: "Soyez jumelé",
        body: "Notre moteur de jumelage trouve le bon organisme, réserve l'événement et crée la page de l'événement.",
      },
      step3: {
        title: "Présentez-vous, c'est tout",
        body: "Votre équipe n'a qu'à se présenter, sans travail administratif. Purposely enregistre les heures et met en lumière les histoires qui valent la peine d'être partagées.",
      },
      verdict: 'Fini les tableurs. Fini de relancer. Laissez votre équipe vraiment se présenter.',
      verdictSub: "La première plateforme de bénévolat construite autour d'une couche d'opérations IA autonome.",
      stats: {
        countries: { n: '25+', label: 'pays' },
        nonprofits: { n: '10 000+', label: 'organismes' },
        setup: { n: '2 min', label: 'pour démarrer' },
      },
    },

    features: {
      eyebrow: 'Fonctionnalités',
      heading_main: 'Une couche IA pour',
      heading_em: 'chaque partie de votre programme',
      nudges: {
        tag: 'Relances intelligentes',
        heading_main: 'Un assistant qui',
        heading_em: 'fait le suivi pour vous',
        body: "Purposely apprend le rythme de chaque employé et envoie des invitations personnalisées au bon moment sur Slack ou Teams — pour qu'aucun quart ne reste vide et qu'aucun collègue ne soit harcelé.",
        bullets: [
          'Intégrations Slack, Teams & Calendrier',
          'Rappels proactifs pour les dates importantes',
          'Rien ne passe entre les mailles du filet',
        ],
        link: 'Voir les intégrations →',
      },
      impact: {
        tag: "Rapports d'impact",
        heading_main: 'Des rapports qui',
        heading_em: 'se rédigent eux-mêmes',
        body: "Nous compilons les heures, les participants, les géographies et bien plus encore, en quelques secondes.",
        bullets: [
          "Suivi par équipe, lieu ou cause",
          "Exportable pour usage interne ou public",
          "Indicateurs conçus pour les rapports RSE, ESG et direction",
        ],
        link: 'Voir le tableau de bord →',
      },
      nonprofits: {
        tag: 'Jumelage intelligent',
        heading_main: 'Des organismes adaptés,',
        heading_em: 'grands et petits',
        body: "Notre moteur de jumelage évalue chaque organisme de notre réseau en fonction des intérêts, de l'emplacement et des priorités de cause de votre équipe. Nous vous présentons des partenaires que vous ne trouveriez jamais dans un répertoire.",
        bullets: [
          'Grandes organisations nationales & organismes locaux',
          'Filtrés par cause, lieu & type d\'événement',
          "Jumelés aux intérêts de votre équipe",
        ],
        link: 'Explorer notre réseau →',
      },
      shifts: {
        tag: 'Gestion intelligente des événements',
        heading_main: 'Des quarts intelligents,',
        heading_em: 'zéro friction',
        body: "Le système optimise le taux de remplissage des quarts en temps réel — en promouvant les employés sur liste d'attente, en rééquilibrant les créneaux sous-occupés et en notifiant votre équipe dès qu'une place se libère. Aucun suivi manuel.",
        bullets: [
          'Plusieurs créneaux par événement',
          "Notifications automatiques pour la liste d'attente",
          'Disponibilité en temps réel pour les employés',
        ],
        link: 'Voir comment les quarts fonctionnent →',
      },
    },

    testimonials: {
      heading: "Ce que disent les équipes que nous avons aidées",
      sub: "Des témoignages d'employés qui ont vécu l'impact de première main.",
    },

    stats: {
      eyebrow: 'Pourquoi ça compte',
      heading: 'Ce que vivent nos clients',
      item1: { n: '87%', description: 'des employés se sentent plus connectés après le bénévolat' },
      item2: { n: '2x', description: 'les équipes bénévoles sont plus susceptibles de rester' },
      item3: { n: '94%', description: 'affirment que Purposely renforce la culture d\'équipe' },
    },

    cta: {
      heading_main: 'Mettez votre programme de bénévolat',
      heading_em: 'sur pilote automatique',
      sub: 'Rejoignez les entreprises qui bâtissent des cultures dont leurs employés sont fiers, et qui gèrent leurs programmes en une fraction du temps.',
      button: 'Réserver une démo →',
    },
  },
}
